import React from 'react';
import { DatePicker } from './DatePicker';

export const TimePicker = React.forwardRef((props, ref) =>
  <DatePicker {...props} picker="time" mode={undefined} ref={ref} onSelect={props.onChange}/>);

TimePicker.displayName = 'TimePicker';
